package ai.beakman.undercover.web

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

/** Código de sala: 4–5 caracteres alfanuméricos (uppercase). */
private val ROOM_CODE_REGEX = Regex("^[A-Z0-9]{4,5}$")

/**
 * Extrai o código de sala da URL para deep-link:
 * - pathname `/sala/CODIGO`
 * - query `?sala=CODIGO`
 */
internal fun parseRoomCode(pathname: String, search: String): String? {
    Regex("^/sala/([A-Za-z0-9]{4,5})/?$").find(pathname)?.let { match ->
        val code = match.groupValues[1].uppercase()
        if (ROOM_CODE_REGEX.matches(code)) return code
    }
    search.removePrefix("?").split('&').forEach { pair ->
        val eq = pair.indexOf('=')
        if (eq > 0 && pair.substring(0, eq) == "sala") {
            val code = decodeURIComponent(pair.substring(eq + 1)).trim().uppercase()
            if (ROOM_CODE_REGEX.matches(code)) return code
        }
    }
    return null
}

private external fun decodeURIComponent(encoded: String): String

fun main() {
    // Firebase (web app "undercover-game-beakman") ANTES de qualquer uso do Firestore.
    Firebase.initialize(
        options = FirebaseOptions(
            applicationId = "1:920175396543:web:c8e942bd8ba3a3d693680a",
            apiKey = "AIzaSyBBSx4v2OoGLtQR0l8Pvr-ZS7NUuj38Y1w",
            projectId = "undercover-game-beakman",
            authDomain = "undercover-game-beakman.firebaseapp.com",
            storageBucket = "undercover-game-beakman.firebasestorage.app",
            gcmSenderId = "920175396543",
        ),
    )

    val initialRoomCode = parseRoomCode(window.location.pathname, window.location.search)

    // Remove o splash estático do index.html antes de montar o Compose.
    document.getElementById("root")?.let { root ->
        while (root.firstChild != null) root.removeChild(root.firstChild!!)
    }

    renderComposable(rootElementId = "root") {
        App(initialRoomCode)
    }
}
